// extracted by mini-css-extract-plugin
export var portfolio = "projects-module--portfolio--I0qeS";
export var projects = "projects-module--projects--RoR2i";